import { render, staticRenderFns } from "./getInfo.vue?vue&type=template&id=2fdd7b12&scoped=true&"
import script from "./getInfo.vue?vue&type=script&lang=js&"
export * from "./getInfo.vue?vue&type=script&lang=js&"
import style0 from "./getInfo.vue?vue&type=style&index=0&id=2fdd7b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdd7b12",
  null
  
)

export default component.exports